import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import RangeSearch from "./components/RangeSearch";
import {useParams} from "react-router-dom";
import dayjs from "dayjs";
import {getMyResults} from "../../store/reducers/ResultsSlice";
import {getUsers} from "../../store/reducers/UsersSlice";

interface MyResultsScreenProps {
}

export const MyResultsScreen: React.FC<MyResultsScreenProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    const resultsState = useAppSelector(state => state.results);

    const [fromDate, setFromDate] = useState<string>('');
    const [toDate, setToDate] = useState<string>('');
    const [user, setUser] = useState<string|null>();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const fromDateParam = urlParams.get("fromDate");
        const toDateParam = urlParams.get("toDate");
        const user = urlParams.get("user");

        const defaultFromDate = dayjs().startOf('month').format('DD.MM.YYYY');
        const defaultToDate = dayjs().format('DD.MM.YYYY');

        setFromDate(fromDateParam || defaultFromDate);
        setToDate(toDateParam || defaultToDate);
        setUser(user || null)
    }, [routeParams]);

    useEffect(() => {
        dispatch(getMyResults());
        dispatch(getUsers());
    }, [routeParams]);

    if ( !resultsState?.me?.total ) {
        return null;
    }

    const generateServiceTable = (services:any) => {
        return (
            <table className="data">
                {services.map((service: any) => (
                    <tr key={service.id}>
                        <td>{service.name}</td>
                        <td>
                            <table>
                                <tr>
                                    <td><strong>Päringuid kokku:</strong></td>
                                    <td>{service.inquiries_count}</td>
                                </tr>
                                <tr>
                                    <td><strong>Päringuid realiseeritud:</strong></td>
                                    <td>{service.realized} {service.realized ? `(${((service.realized / service.inquiries_count) * 100).toFixed(2)}%)` : ''}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                ))}
            </table>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <h1>Minu tulemused {fromDate} - {toDate}</h1>
            <RangeSearch url={'/results/me'} userVisible={true} />
            <>
                <h2>Üldised tulemused</h2>
                <table className="data">
                    <tr><td><strong>Päringuid kokku:</strong></td><td>{resultsState.me.total.count_total}</td></tr>
                    <tr><td><strong>Päringuid realiseeritud:</strong></td><td>{resultsState.me.total.count_realized} ({resultsState.me.total.percent_realized}%)</td></tr>
                    <tr><td><strong>Kogu kasum:</strong></td><td>{resultsState.me.total.profit_total}</td></tr>
                    <tr><td><strong>Keskmine kasum:</strong></td><td>{(resultsState.me.total.profit_total/resultsState.me.total.count_realized).toFixed(2)}</td></tr>
                    <tr><td><strong>Päringuid veebist EST:</strong></td><td>{resultsState.me.total.count_web_total}</td></tr>
                    <tr><td><strong>Päringuid veebist FIN:</strong></td><td>{resultsState.me.total.count_web_total_fin}</td></tr>
                    <tr><td><strong>Päringuid veebist SWE:</strong></td><td>{resultsState.me.total.count_web_total_swe}</td></tr>
                    <tr><td><strong>Realiseeritud EST veebipäringud:</strong></td><td>{resultsState.me.total.count_realized_web} ({resultsState.me.total.percent_realized_web}%)</td></tr>
                    <tr><td><strong>Realiseeritud FIN veebipäringud:</strong></td><td>{resultsState.me.total.count_realized_web_fin} ({resultsState.me.total.percent_realized_web_fin}%)</td></tr>
                    <tr><td><strong>Realiseeritud SWE veebipäringud:</strong></td><td>{resultsState.me.total.count_realized_web_swe} ({resultsState.me.total.percent_realized_web_swe}%)</td></tr>
                    <tr><td><strong>Reklamatsioone:</strong></td><td>{resultsState.me.total.reclamation_count}</td></tr>
                </table>
                {resultsState.me.services.length > 0 && (
                    <>
                        <h2>Teenuse liigid</h2>
                        {generateServiceTable(resultsState.me.services)}
                    </>
                )}
            </>
        </LoggedInView>
    )

}